import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  formateDate,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import DragDrop from "../DragDrop/DragDrop";
import { showErrorMessage, showSuccessMessage } from "../Shared/Toast";

function ContentLibrary() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [ShowCopyDrop, SetShowCopyDrop] = useState(false);
  const ShowHideCopyDrop = () => {
    SetShowCopyDrop(!ShowCopyDrop);
  };

  const [copyType, SetCopyType] = useState(1);

  const [addEditObject, setAddEditObject] = useState<any>({});
  const [searchText, setSearchText] = useState("");
  const [filteredAttachments, setFilteredAttachments] = useState<any>([]);
  const [filterObject, setFilterObject] = useState({
    type: 1,
    folder: 0,
  });
  const [sortObject, setSortObject] = useState({
    name: 2,
    order: 2,
  });
  const [showModal, setShowModal] = useState(false);
  const [folderObject, setFolderObject] = useState({
    MGContentFolderID: 0,
    Name: "",
  });

  const [showImageModal, setShowImageModal] = useState(false);
  const [imageObject, setImageObject] = useState({
    PTAttachmentID: 0,
    ImageTitle: "",
    AltText: "",
  });

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadedFolderID, setuploadedFolderID] = useState(0);

  const [folderData, setFolderData] = useState<any>([]);
  const [attachmentsData, setAttachmentsData] = useState<any>([]);
  const [ShowSearchBox, SetShowSearchBox] = useState(false);
  const ShowHideSearchBox = () => {
    SetShowSearchBox(!ShowSearchBox);
  };

  useEffect(() => {
    getFolderData();
  }, []);

  useEffect(() => {
    getAttachmentData();
  }, [filterObject, sortObject]);

  function getFolderData() {
    setIsAnimation(true);
    let object = {} as any;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MGContentFolder/MGContentFolderGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;

          setFolderData(l_oResponse[0]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getAttachmentData() {
    setIsAnimation(true);
    let object = {} as any;
    object.contenttypeid = filterObject.type;
    object.objectid = filterObject.folder;
    object.attachmenttypeid = dragDropFeatures.ObjectType;
    object.sortbycolumn = sortObject.name;
    object.sortbyorder = sortObject.order;
    axiosAuth
      .post(AppContext.APIURL + "api/PTAttachment/GetAttachmentData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;

          setAttachmentsData(l_oResponse[0]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function updateArray(p_index: any, colName: any) {
    let dataArray = [...attachmentsData];
    for (let index = 0; index < dataArray.length; index++) {
      if (p_index != index) dataArray[index][colName] = false;
    }

    dataArray[p_index][colName] = !dataArray[p_index][colName];
    setAttachmentsData(dataArray);
  }

  function checkValidation() {
    var IsOkay = true;
    if (folderObject.Name == "") {
      IsOkay = false;
    }
    if (IsOkay == true) {
      saveFolderData();
    } else {
      showErrorMessage("Name required");
    }
  }

  function editFolder(MGContentFolderID: any) {
    let Name = "";
    let Id = 0;
    for (let index = 0; index < folderData.length; index++) {
      if (folderData[index].MGContentFolderID == MGContentFolderID) {
        Name = folderData[index].Name;
        Id = folderData[index].MGContentFolderID;
        break;
      }
    }
    if (Id > 0) {
      folderObject.MGContentFolderID = Id;
      folderObject.Name = Name;
      setShowModal(true);
    } else {
      folderObject.MGContentFolderID = 0;
      folderObject.Name = "";
    }
  }

  function saveFolderData() {
    setIsAnimation(true);
    let object = {} as any;
    object.mgcontentfolderid = folderObject.MGContentFolderID;
    object.name = folderObject.Name;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MGContentFolder/MGContentFolderSaveCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
        }
        getFolderData();
        setShowModal(false);
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisFolder(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.mgcontentfolderid = pid;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MGContentFolder/MGContentFolderDeleteRecordCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
        }
        filterObject.folder = 0;
        getFolderData();
        setShowModal(false);
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function updateImageData() {
    setIsAnimation(true);
    let object = {} as any;
    object.ptattachmentid = imageObject.PTAttachmentID;
    object.alttext = imageObject.AltText;
    object.imagetitle = imageObject.ImageTitle;
    axiosAuth
      .post(
        AppContext.APIURL + "api/PTAttachment/PTAttachmentUpdateRecord",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
        }
        getAttachmentData();
        setShowImageModal(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisAttachment(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.ptattachmentid = pid;
    axiosAuth
      .post(
        AppContext.APIURL + "api/PTAttachment/PTAttachmentDeleteRecordCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
        }
        getAttachmentData();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function editImageData(item: any) {
    imageObject.PTAttachmentID = item.PTAttachmentID;
    imageObject.AltText = item.AltText;
    imageObject.ImageTitle = item.ImageTitle;
    setShowImageModal(true);
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisFolder(obj.SelectedID);
      }
    }
    if (obj.ID === 2) {
      if (obj.isConfirm === true) {
        deleteThisAttachment(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  useEffect(() => {
    if (!searchText.trim()) {
      setFilteredAttachments(attachmentsData);
    } else {
      const lowerSearch = searchText.toLowerCase();
      const filtered = attachmentsData.filter(
        (item: any) =>
          item.ImageTitle?.toLowerCase().includes(lowerSearch) ||
          item.AltText?.toLowerCase().includes(lowerSearch) ||
          item.FileURLRaw?.toLowerCase().includes(lowerSearch)
      );
      setFilteredAttachments(filtered);
    }
  }, [searchText, attachmentsData]);

  //Dragdrop starts
  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: 786121,
    MaxAllowedFiles: 10,
    UploadType: 1,
    FolderName: "ContentLibrary",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState<any>([]);
  const [triggerChild, setTriggerChild] = useState(false);

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
    // SaveFiles(ChildData);
  }
  async function SaveFiles() {
    if (
      uploadFileList &&
      uploadFileList.length > 0 &&
      !uploadFileList[0].AlreadyUploaded
    ) {
      setIsAnimation(true);
      const object: any = {
        typeid: 1,
        attachmenttype: dragDropFeatures.ObjectType,
        objectid: dragDropFeatures.ObjectID,
        applicationid: 1,
        foldername: "ResourceLibrary",
        filesdata: uploadFileList,
        resoption: "1-1200-0,1-900-0,1-600-0,1-340-220,1",
      };

      try {
        const response = await axiosAuth.post(
          AppContext.FilesAPI + "api/PTAttachment/SaveFilesDataV2",
          object
        );

        if (response.data.Status === 1) {
          setTriggerChild(!triggerChild);
          const l_response = response.data.Data;
          setuploadedFolderID(0);
          setShowUploadModal(false);
          getAttachmentData();
        } else {
          // console.log("error", response.data.Message);
          setIsAnimation(false);
        }
      } catch (error) {
        console.error("There was an error!", error);
        setIsAnimation(false);
      }
    } else {
      showErrorMessage("Upload Media");
    }
  }

  function uploadMedia() {
    setuploadedFolderID(filterObject.folder);
    dragDropFeatures.ObjectID = filterObject.folder;
    setShowUploadModal(true);
  }

  function checkValidationForUploads() {
    var IsOkay = true;
    if (uploadedFolderID == 0) {
      IsOkay = false;
    }
    if (IsOkay == true) {
      SaveFiles();
    } else {
      showErrorMessage("Please select folder");
    }
  }

  function copyThisLink(
    type: any,
    linkToCopy: string,
    altText?: string,
    title?: string
  ) {
    linkToCopy = linkToCopy.replace("/raw/", type);
    
    if (copyType == 1) {
      copyToclipBoard(linkToCopy);
    } else if (copyType == 2) {
      copyToClipboardWithSource(type, linkToCopy, altText, title);
    }
  }

  function copyToclipBoard(linkToCopy: any) {
    navigator.clipboard
      .writeText(linkToCopy)
      .then(function () {
        showSuccessMessage("Copied to clipboard");
      })
      .catch(function (err) {
        console.error("Could not copy text: ", err);
      });
  }

  function copyToClipboardWithSource(
    type: any,
    linkToCopy: string,
    altText?: string,
    title?: string
  ) {
    if (!linkToCopy) return;

    const fileExtension = linkToCopy.split(".").pop()?.toLowerCase() || "";
    const safeAlt = altText || "image";
    const safeTitle = title || "Download Document";

    let sizeAttr =
      type == "/raw/" || type == "/org/" ? "" : ` width="300" height="350"`;

    sizeAttr = "";

    let htmlContent = "";

    if (
      ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"].includes(
        fileExtension
      )
    ) {
      // 🖼️ Image
      htmlContent = `<img src="${linkToCopy}" alt="${safeAlt}" title="${safeTitle}" ${sizeAttr} />`;
    } else if (
      ["mp4", "webm", "ogg", "mov", "avi", "mkv"].includes(fileExtension)
    ) {
      // 🎥 Video
      htmlContent = `<video ${sizeAttr} controls title="${safeTitle}">
  <source src="${linkToCopy}" type="video/${fileExtension}" />
  Your browser does not support the video tag.
  </video>`;
    } else if (["mp3", "wav", "ogg"].includes(fileExtension)) {
      // 🎵 Audio
      htmlContent = `<audio controls title="${safeTitle}">
  <source src="${linkToCopy}" type="audio/${fileExtension}" />
  Your browser does not support the audio element.
</audio>`;
    } else if (
      ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt"].includes(
        fileExtension
      )
    ) {
      // 📄 Document
      htmlContent = `<a href="${linkToCopy}" target="_blank" title="${safeTitle}">${safeTitle}</a>`;
    } else {
      // 🔗 Default hyperlink
      htmlContent = `<a href="${linkToCopy}" target="_blank" title="${safeTitle}">${linkToCopy}</a>`;
    }

    navigator.clipboard
      .writeText(htmlContent)
      .then(() => {
        showSuccessMessage("Copied to clipboard");
      })
      .catch((err) => {
        console.error("Could not copy text: ", err);
      });
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      <>
        <div className="flex-d justify-btw mb-10 wrap-flex flex-gap15">
          <div className="flex-da gap-10 wrap-flex">
            <div className="field-input">
              <select
                className="input-field"
                value={filterObject.type}
                onChange={(e) =>
                  setFilterObject((prevState: any) => ({
                    ...prevState,
                    type: e.target.value,
                  }))
                }
              >
                <option value={1}>Images</option>
                <option value={2}>Videos</option>
                <option value={3}>Documents</option>
              </select>
            </div>
            <div className="field-input">
              <select
                className="input-field"
                value={filterObject.folder}
                onChange={(e) =>
                  setFilterObject((prevState: any) => ({
                    ...prevState,
                    folder: e.target.value,
                  }))
                }
              >
                <option value={0}>All Folders</option>
                {folderData &&
                  folderData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      <option value={item.PID}>{item.Name}</option>
                    </React.Fragment>
                  ))}
              </select>
            </div>
            {filterObject.folder > 0 && (
              <a
                title="Manage folder"
                onClick={() => editFolder(filterObject.folder)}
                className="icon-btn"
              >
                <img
                  src="images/edit-w.svg"
                  width="18px"
                  height="18px"
                  alt="Edit"
                />
              </a>
            )}
            <div className="flex-daj btn-start">
              <a
                className="btn-primary flex-daj"
                onClick={() => {
                  folderObject.Name = "";
                  folderObject.MGContentFolderID = 0;
                  setShowModal(true);
                }}
              >
                Add Folder
              </a>
            </div>
          </div>
          <div className="flex-daj flex-gap10 wrap-flex">
            Sort by:
            <div className="field-input">
              <select
                className="input-field small-input"
                value={sortObject.name}
                onChange={(e) =>
                  setSortObject((prevState: any) => ({
                    ...prevState,
                    name: e.target.value,
                  }))
                }
              >
                <option value={1}>Name</option>
                <option value={2}>Date</option>
              </select>
            </div>
            <div className="field-input">
              <select
                className="input-field small-input"
                value={sortObject.order}
                onChange={(e) =>
                  setSortObject((prevState: any) => ({
                    ...prevState,
                    order: e.target.value,
                  }))
                }
              >
                <option value={1}>Asc</option>
                <option value={2}>Desc</option>
              </select>
            </div>
            <div className="flex-da">
              {ShowSearchBox && (
                <input
                  className="input-find"
                  placeholder="Search..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              )}
              <a
                onClick={ShowHideSearchBox}
                className={`icon-btn ${
                  ShowSearchBox === true ? "rem-radius" : ""
                }`}
              >
                <img
                  src="images/search-w.svg"
                  width="18px"
                  height="18px"
                  alt="Search"
                />
              </a>
            </div>
            <div className="flex-daj btn-start">
              <a className="btn-primary flex-daj" onClick={() => uploadMedia()}>
                Upload
              </a>
            </div>
            {/* <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() => DownloadClientsDataInExcel("tblmover", "Mover")}
            >
              <img src="images/export.svg" width="18" height="18" />
            </a> */}
          </div>
        </div>
        <div className="library-data">
          {filteredAttachments &&
            filteredAttachments.map((item: any, index: any) => (
              <React.Fragment key={index}>
                <div className="library-item">
                  <div className="flex-da flex-gap10 lib-controls">
                    <a
                      onClick={() =>
                        globalState.setConfirmationModalObject({
                          ShowPopup: true,
                          Heading: "Confirmation",
                          Message:
                            "Are you sure you want to delete this record?",
                          ID: 2,
                          SelectedID: item.PTAttachmentID,
                          OtherID: 0,
                        })
                      }
                      className="flex-d"
                    >
                      <img
                        src="images/del-w.svg"
                        width={15}
                        height={15}
                        alt="Delete"
                      />
                    </a>

                    <a onClick={() => editImageData(item)} className="flex-d">
                      <img
                        src="images/edit-w.svg"
                        width={15}
                        height={15}
                        alt="Edit"
                      />
                    </a>
                  </div>

                  <a
                    href={item.FileURLRaw}
                    target="_blank"
                    className="lib-image"
                  >
                    <img
                      src={AppContext.GetFileIconToDisplay(
                        item.URLLinkToDisplay
                      )}
                      width="100px"
                      height="100px"
                      alt="img"
                    />
                  </a>
                  <div className="flex-da justify-btw lib-title-box">
                    <span className="lib-title">{item.ImageTitle}</span>
                    {/* <a
                      title="Copy embeded code to clipboard"
                      onClick={() =>
                        copyToClipboardWithSource(
                          item.FileURLRaw,
                          item.AltText,
                          item.ImageTitle
                        )
                      }
                      className="flex-d"
                    >
                      <img
                        src="images/embed.svg"
                        width={15}
                        height={15}
                        alt="Embed"
                      />
                    </a> */}
                    <div className="flex-d p-relative">
                      <a
                        title="Copy link to clipboard"
                        // onClick={() => copyToclipBoard(item.FileURLRaw)}
                        onClick={() => updateArray(index, "ShowCopyOptions")}
                        className="link-copy flex-gap5 flex-d flex-ac bold-font"
                      >
                        <img
                          src="images/clipboard.svg"
                          width={15}
                          height={15}
                          alt="Clipboard"
                        />
                      </a>
                      {item.ShowCopyOptions && (
                        <div className="copy-dropdown">
                          <div className="copy-tab">
                            <a
                              className={copyType == 1 ? "selected" : ""}
                              onClick={() => SetCopyType(1)}
                            >
                              Copy Image Link
                            </a>
                            <a
                              className={copyType == 2 ? "selected" : ""}
                              onClick={() => SetCopyType(2)}
                            >
                              Copy Embed code
                            </a>
                          </div>
                          <div className="grid-d copy-list">
                            {/* {item.FileURLOrg != "" && (
                              <a
                                onClick={() => {
                                  copyThisLink(
                                    "/org/",
                                    item.FileURLRaw,
                                    item.AltText,
                                    item.ImageTitle
                                  );
                                  updateArray(index, "ShowCopyOptions");
                                }}
                              >
                                Original Compressed Image
                              </a>
                            )}
                            {item.FileURLLg != "" && (
                              <a
                                onClick={() => {
                                  copyThisLink(
                                    "/lg/",
                                    item.FileURLRaw,
                                    item.AltText,
                                    item.ImageTitle
                                  );
                                  updateArray(index, "ShowCopyOptions");
                                }}
                              >
                                Large Image (width:1200px)
                              </a>
                            )}
                            {item.FileURLMd != "" && (
                              <a
                                onClick={() => {
                                  copyThisLink(
                                    "/md/",
                                    item.FileURLRaw,
                                    item.AltText,
                                    item.ImageTitle
                                  );
                                  updateArray(index, "ShowCopyOptions");
                                }}
                              >
                                Medium Image (width:900px)
                              </a>
                            )}
                            {item.FileURLSm != "" && (
                              <a
                                onClick={() => {
                                  copyThisLink(
                                    "/sm/",
                                    item.FileURLRaw,
                                    item.AltText,
                                    item.ImageTitle
                                  );
                                  updateArray(index, "ShowCopyOptions");
                                }}
                              >
                                Small Image (width:600px)
                              </a>
                            )}
                            {item.FileURLTh && item.FileURLTh != "" && (
                              <a
                                onClick={() => {
                                  copyThisLink(
                                    "/th/",
                                    item.FileURLRaw,
                                    item.AltText,
                                    item.ImageTitle
                                  );
                                  updateArray(index, "ShowCopyOptions");
                                }}
                              >
                                Thumbnail (width:340px, height:220px)
                              </a>
                            )} */}
                            {item.FileURLRaw != "" && (
                              <a
                                onClick={() => {
                                  copyThisLink(
                                    "/raw/",
                                    item.FileURLRaw,
                                    item.AltText,
                                    item.ImageTitle
                                  );
                                  updateArray(index, "ShowCopyOptions");
                                }}
                              >
                                Original Raw Image
                              </a>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}
        </div>
      </>

      {showModal && (
        <div className="popup-help popup-help-index low-zindex">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                {folderObject.MGContentFolderID == 0 && (
                  <h3 className="bold-font flex-d m-all0">Add Folder</h3>
                )}
                {folderObject.MGContentFolderID > 0 && (
                  <h3 className="bold-font flex-d m-all0">Update Folder</h3>
                )}
                <a className="close-help" onClick={() => setShowModal(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="popup-message mt-20 p-all0">
                <div className="grid-d fr-1 gap-20">
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Folder Name:
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder=""
                      type="text"
                      value={folderObject.Name}
                      onChange={(e) =>
                        setFolderObject((prevState: any) => ({
                          ...prevState,
                          Name: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="flex-daj gap-10 mt-20">
                {folderObject.MGContentFolderID > 0 && (
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() =>
                        globalState.setConfirmationModalObject({
                          ShowPopup: true,
                          Heading: "Confirmation",
                          Message:
                            "Are you sure you want to delete this record?",
                          ID: 1,
                          SelectedID: folderObject.MGContentFolderID,
                          OtherID: 0,
                        })
                      }
                    >
                      Delete
                    </a>
                  </div>
                )}
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => checkValidation()}
                  >
                    {folderObject.MGContentFolderID == 0 ? "Save" : "Update"}
                  </a>
                </div>
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showUploadModal && (
        <div className="popup-help popup-help-index low-zindex">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Upload</h3>
                <a
                  className="close-help"
                  onClick={() => setShowUploadModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="grid-d fr-1 mt-20 p-all0 gap-20">
                <div className="field-input grid-d  flex-gap3">
                  <span className="font-12 text-left label-color">Folder</span>
                  <select
                    className="input-field w-100"
                    value={uploadedFolderID}
                    onChange={(e: any) => {
                      dragDropFeatures.ObjectID = e.target.value;
                      setuploadedFolderID(e.target.value);
                    }}
                  >
                    <option value={0}>Select Folder</option>
                    {folderData &&
                      folderData.map((item: any, index: any) => (
                        <React.Fragment key={index}>
                          <option value={item.PID}>{item.Name}</option>
                        </React.Fragment>
                      ))}
                  </select>
                </div>

                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    <div className="field-input grid-d g-c-fw">
                      <DragDrop
                        ParentFeatures={dragDropFeatures}
                        DragDropCallback={handleDragDropCallback}
                        TriggerChild={triggerChild}
                      />
                    </div>
                  </span>
                </div>
              </div>
              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => checkValidationForUploads()}
                  >
                    Save
                  </a>
                </div>
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowUploadModal(false)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showImageModal && (
        <div className="popup-help popup-help-index low-zindex">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                Update
                <a
                  className="close-help"
                  onClick={() => setShowImageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="popup-message mt-20 p-all0">
                <div className="grid-d fr-1 gap-20">
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Title:
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder=""
                      type="text"
                      value={imageObject.ImageTitle}
                      onChange={(e) =>
                        setImageObject((prevState: any) => ({
                          ...prevState,
                          ImageTitle: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Alt Text:
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder=""
                      type="text"
                      value={imageObject.AltText}
                      onChange={(e) =>
                        setImageObject((prevState: any) => ({
                          ...prevState,
                          AltText: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => updateImageData()}
                  >
                    Update
                  </a>
                </div>

                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowImageModal(false)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ContentLibrary;
